/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrganizationUserDto
 */
export interface CreateOrganizationUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationUserDto
     */
    organizationId?: string | null;
}

/**
 * Check if a given object implements the CreateOrganizationUserDto interface.
 */
export function instanceOfCreateOrganizationUserDto(value: object): value is CreateOrganizationUserDto {
    return true;
}

export function CreateOrganizationUserDtoFromJSON(json: any): CreateOrganizationUserDto {
    return CreateOrganizationUserDtoFromJSONTyped(json, false);
}

export function CreateOrganizationUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
    };
}

export function CreateOrganizationUserDtoToJSON(json: any): CreateOrganizationUserDto {
    return CreateOrganizationUserDtoToJSONTyped(json, false);
}

export function CreateOrganizationUserDtoToJSONTyped(value?: CreateOrganizationUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'organizationId': value['organizationId'],
    };
}

